export const cartDataLoading = "cart/data/loading";
export const cartDataSuccess = "cart/data/success";
export const cartDataError = "cart/data/error";

export const deleteLoading = "delete/loading";
export const deleteSuccess = "delete/success";
export const deleteError = "delete/error";

export const addToBagLoading = "addToBag/loading";
export const addToBagSuccess = "addToBag/success";
export const addToBagError = "addToBag/error";
